import React from "react";
import { app_directory } from "../config/config";
import styles from "../styles/logo.module.scss";

const Logo = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.mainContainer}>
        <img src={`/${app_directory}/logo.png`} alt="logo" height="30" />
      </div>
    </div>
  );
};

export default Logo;
